<ng-container *ngIf="role && role !== 'TECHEXPERT'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as TECHEXPERT, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<mat-spinner class="comeOnTop" *ngIf="pdfLoading"></mat-spinner>
<ng-container *ngIf="role && role === 'TECHEXPERT'">
  <div style="text-align:center">
    <br>
    

    <form [formGroup]="filterForm" style="text-align: center;">
      <mat-form-field id="formField" appearance="fill">
        <mat-label id="head">Select Date Range:
          <mat-icon id="icon" matDatepickerToggleIcon (click)="clearDate($event)">clear</mat-icon>
        </mat-label>
        <mat-date-range-input [rangePicker]="picker" >
          <input formControlName="startDate" matStartDate placeholder="Start date" required>
          <input formControlName="endDate" matEndDate placeholder="End date" required>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <!-- (click)="" -->
      <button class="btn btn-outline-primary filter-btn"  (click)="filter()">Filter transactions</button>
      
      <button type="button" class="btn btn-warn" style="margin-left: 10px;" (click)="reset()">RESET</button>
      <mat-error *ngIf="missingFields">Date Range is required</mat-error>
    </form>

    <button class="btn btn-success" (click)="sendInvoiceDateFilter()">Generate Transaction report</button>

    <!-- <ng-template #mymodal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Select Date Range for Invoice</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>


      <div class="modal-body">
        <form [formGroup]="filterForm" (submit)="sendInvoiceDateFilter()" style="text-align: center;">
          <mat-form-field id="formField" appearance="fill">
            <mat-label id="head">Select Date Range:
              <mat-icon id="icon" matDatepickerToggleIcon (click)="clearDate($event)">clear</mat-icon>
            </mat-label>
            <mat-date-range-input [rangePicker]="picker" >
              <input formControlName="startDate" matStartDate placeholder="Start date" required>
              <input formControlName="endDate" matEndDate placeholder="End date" required>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <button class="btn btn-success" type="submit">Generate Invoice</button>
          <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
          <mat-error *ngIf="missingFields">Date Range is required</mat-error>
        </form>
      </div>


      <br>

    </ng-template> -->
    <ng-container *ngIf="paidTransactions">
      <div class="alert alert-primary" role="alert" *ngIf="paidTransactions.length !== 0">
        Your Paid Transactions
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="paidTransactions.length === 0">
        No paid Transactions to display
      </div>
      <div class="card">
        <div class="card-body">
          <table class="table table-hover" *ngIf="paidTransactions.length !== 0">
            <thead class=" text-primary">
              <tr>
                <th scope="col">Transaction ID</th>
                <th scope="col">Ticket ID</th>
                <th scope="col">Created On</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of paidTransactions">
                <td>{{ transaction._id }}</td>
                <td>{{ transaction.ticketId }}</td>
                <td>{{ transformDate(transaction.createdAt) }}</td>
                <td>{{ transaction.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="unpaidTransactions">
      <div class="alert alert-primary" role="alert" *ngIf="unpaidTransactions.length !== 0">
        Your Unpaid Transactions
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="unpaidTransactions.length === 0">
        No unpaid Transactions to display
      </div>
      <div class="card">
        <div class="card-body">
          <table class="table table-hover" *ngIf="unpaidTransactions.length !== 0">
            <thead class=" text-primary">
              <tr>
                <th scope="col">Transaction ID</th>
                <th scope="col">Ticket ID</th>
                <th scope="col">Created On</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of unpaidTransactions">
                <td>{{ transaction._id }}</td>
                <td>{{ transaction.ticketId }}</td>
                <td>{{ transformDate(transaction.createdAt) }}</td>
                <td>{{ transaction.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>


    <!-- <button class="btn btn-success" (click)="sendInvoiceDateFilter()">Generate Transaction report</button> -->
  </div>
</ng-container>
